import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {SortingOptionSelectedEvent} from "./events";
import eventHandlers from "./eventHandlers";

let sortButton: Element;
let sortBox: Element;
let sortingItems: Element[];

const SORTING_ITEMS_SELECTOR = 'div[data-sort-item="true"]';

function init(ev: any = EventBus.getInstance()) {
    const eventBus: EventBus = ev;
    eventHandlers.init();

    sortButton = dom.select("#sort-button")!;
    sortBox = dom.select("#sort-box")!;
    sortingItems = dom.selectAll(SORTING_ITEMS_SELECTOR)!;

    openSortingBox();
    closeSortingBox();

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: SORTING_ITEMS_SELECTOR,
        listener(this: HTMLInputElement) {
            const optionValue = this.dataset.value;
            const currentUrl = window.location.href
            eventBus.emit(new SortingOptionSelectedEvent({optionValue, currentUrl}))
        }
    }))
}

function openSortingBox() {
    let selectedSorting = false;
    sortingItems.forEach((element) => {
        if (element.classList.contains("sort-item--selected")) {
            selectedSorting = true;
        }
    })
    if (!selectedSorting) selectFirstOptionByDefault()
    if (sortButton != null) {
        sortButton.addEventListener('click', () => {
            if (sortBox.classList.contains("sort-box--displayed")) {
                sortBox.classList.remove("sort-box--displayed")
            } else {
                displaySorting();
            }
        })
    }
}

function closeSortingBox() {
    document.addEventListener('click', function (event) {
        if (sortButton != null && !sortButton.contains(event.target as Node)) {
            if (sortBox.classList.contains("sort-box--displayed")) {
                sortBox.classList.remove("sort-box--displayed")
            }
        }
    })
}

function selectFirstOptionByDefault() {
    if (sortingItems.length > 0) {
        sortingItems[0].classList.add("sort-item--selected")
    }
}

function displaySorting() {
    sortBox.classList.add("sort-box--displayed")
}

export default {
    init,
}